export class Statistics {
    constructor() {
        this.AccountOperationStatistic = new Map();
        this.Type = null;
        this.BeginProjectedBalance = null;
    }
    FillByMessage(message) {
        this.Type = message.Type;
        if (message.BeginProjectedBalance !== null) {
            this.BeginProjectedBalance = message.BeginProjectedBalance;
        }
        if (isValidArray(message.AccountOperationStatistic)) {
            message.AccountOperationStatistic.forEach((statistic) => {
                this.AccountOperationStatistic.set(statistic.OperationType, statistic.Amount);
            });
        }
    }
}
